import {
  FleetVehicleDetailFormValues,
  FleetVehicleEditFormValues,
  FleetVehicleImportModalFormValues,
  //   VehicleDetailFormValues,
  //   VehicleEditFormValues,
  //   VehicleImage,
  FleetVehicleSearchFormValues,
  FleetVehicleStatusConfig,
  FleetVehicleStatusDetailFieldConfig,
  FleetVehicleStatusDetailFormValues,
  FleetVehicleStatusEnum,
} from "./types";
import { VehicleLocationTypeEnum } from "./locations/types";

// /*-------------------------------------------------------------------------------------------
//   VEHICLE EDIT
// ---------------------------------------------------------------------------------------------*/

export const initialFleetVehicleEditForm: FleetVehicleEditFormValues = {
  vehicleCategoryId: "A",
  vehicleManufacturerId: "",
  vehicleModelId: null,
  vehicleTypeId: null,
  vinNumber: "",
  firstRegistrationDate: null,
  registrationPlate: "",
  registrationExpiration: null,
  kmTraveled: null,
  vehicleColorId: null,
  colorName: null,
  netPrice: null,
  discountType: 'percentage',
  discountValue: null,
  netDiscount: null,
  specialTax: null,
  ecoFee: null,
  vehicleInVatSystem: true,
  sellingPrice: null,
  ownerTypeId: null,
  ownerContactId: null,
  purchaseDate: null,
  leaseActivationDate: null,
  warrantyExpirationDate: null,
  warrantyMileageLimit: null,
  autoInsuranceContactId: null,
  autoInsuranceExpiryDate: null,
  cascoExpiryDate: null,
  cascoContactId: null,
  // Novo vozilo kreće kao slobodno; korisnik može promijeniti u koraku Info.
  status: FleetVehicleStatusEnum.AVAILABLE,
  // Lokacija je neobavezna — dok je korisnik ne popuni ostaje prazna i ne šalje se,
  // inače bi svako spremanje koraka slalo poluprazan premještaj koji backend odbija.
  location: null,
  pictures: [],
  tiresCount: 0
};

// export const initialVehicleImage: VehicleImage = {
//   images: [],

// };

/*-------------------------------------------------------------------------------------------
  VEHICLE SEARCH
---------------------------------------------------------------------------------------------*/

/**
 * Zadani filter pretrage — svi statusi osim prodanih. Prodano vozilo je arhivirano,
 * pa se ne prikazuje dok ga korisnik izričito ne uključi u dropdownu.
 * Izvodi se iz enuma (a ne iz FLEET_VEHICLE_STATUS_CONFIG) jer je config definiran niže.
 */
export const DEFAULT_VEHICLE_STATUS_FILTER: string[] = Object.values(
  FleetVehicleStatusEnum
).filter((status) => status !== FleetVehicleStatusEnum.SOLD);

export const initialFleetVehicleSearchForm: FleetVehicleSearchFormValues = {
  search: "",
  vehicleCategoryId: null,
  vehicleManufacturerId: "",
  vehicleModelId: null,
  vehicleTypeId: null,
  vinNumber: null,
  registrationPlate: null,
  firstRegistrationDateFrom: null,
  firstRegistrationDateTo: null,
  registrationExpirationFrom: null,
  registrationExpirationTo: null,
  kwFrom: null,
  kwTo: null,
  kmTraveledFrom: null,
  kmTraveledTo: null,
  condition: null,
  fuelType: null,
  statuses: DEFAULT_VEHICLE_STATUS_FILTER,
  officeId: null,
  advancedSearch: [],
};

// /*-------------------------------------------------------------------------------------------
//   VEHICLE DETAILS
// ---------------------------------------------------------------------------------------------*/

export const initialFleetVehicleDetailForm: FleetVehicleDetailFormValues = {
  id: null,
  vehicleColorId: null,
  colorName: null,
  created: null,
  cylinderCapacity: null,
  firstRegistrationDate: null,
  fuelType: null,
  hp: null,
  kmTraveled: null,
  kw: null,
  name: null,
  registrationExpiration: null,
  registrationPlate: null,
  secondaryFuelType: null,
  price: {
    netPrice: null,
    specialTax: null,
    ecoFee: null,
    vehicleInVatSystem: false,
    sellingPrice: null,
    discountType: null,
    discountValue: null,
    netDiscount: null,
    totalPurchasePrice: null,
    margin: null,
    marginPercentage: null,
    totalExpenses: null,
    netMargin: null,
    netMarginPercentage: null,
  },
  vehicleManufacturer: null,
  vehicleModel: null,
  vehicleType: null,
  vinNumber: null,
  warrantyExpirationDate: null,
  warrantyMileageLimit: null,
  autoInsuranceContact: null,
  autoInsuranceExpiryDate: null,
  cascoContact: null,
  cascoExpiryDate: null,
  status: null,
  location: null,
  pictures: []

};


/*---------------------------------------------------------------
    IMPORT
  ---------------------------------------------------------------*/

export const initialVehicleImportModalForm: FleetVehicleImportModalFormValues = {
  files: []
}




export const FLEET_VEHICLE_STATUS_CONFIG: Record<
  FleetVehicleStatusEnum,
  FleetVehicleStatusConfig
> = {
  [FleetVehicleStatusEnum.ARRIVING]: {
    label: "admin.fleet.vehicle.status.arriving",
    color: "bg-amber-100 text-amber-800",
    dotColor: "bg-amber-500",
    strokeColor: "stroke-amber-500",
    parentStatus: null,
  },

  [FleetVehicleStatusEnum.AVAILABLE]: {
    label: "admin.fleet.vehicle.status.available",
    color: "bg-green-100 text-green-800",
    dotColor: "bg-green-500",
    strokeColor: "stroke-green-500",
    parentStatus: null,
  },

  [FleetVehicleStatusEnum.RESERVED]: {
    label: "admin.fleet.vehicle.status.reserved",
    color: "bg-purple-100 text-purple-800",
    dotColor: "bg-purple-500",
    strokeColor: "stroke-purple-500",
    parentStatus: null,
  },

  [FleetVehicleStatusEnum.ACTIVE]: {
    label: "admin.fleet.vehicle.status.active",
    color: "bg-blue-100 text-blue-800",
    dotColor: "bg-blue-500",
    strokeColor: "stroke-blue-500",
    parentStatus: null,
    subStatuses: [
      FleetVehicleStatusEnum.ACTIVE_RENTAL,
      FleetVehicleStatusEnum.ACTIVE_INTERNAL,
    ],
  },

  [FleetVehicleStatusEnum.ACTIVE_RENTAL]: {
    label: "admin.fleet.vehicle.status.active.rental",
    color: "bg-blue-100 text-blue-800",
    dotColor: "bg-blue-500",
    strokeColor: "stroke-blue-500",
    parentStatus: FleetVehicleStatusEnum.ACTIVE,
  },

  [FleetVehicleStatusEnum.ACTIVE_INTERNAL]: {
    label: "admin.fleet.vehicle.status.activeinternal",
    color: "bg-blue-100 text-blue-800",
    dotColor: "bg-blue-500",
    strokeColor: "stroke-blue-500",
    parentStatus: FleetVehicleStatusEnum.ACTIVE,
  },

  [FleetVehicleStatusEnum.UNAVAILABLE]: {
    label: "admin.fleet.vehicle.status.unavailable",
    color: "bg-slate-100 text-slate-800",
    dotColor: "bg-slate-500",
    strokeColor: "stroke-slate-500",
    parentStatus: null,
    subStatuses: [
      FleetVehicleStatusEnum.UNAVAILABLE_SERVICE,
      FleetVehicleStatusEnum.UNAVAILABLE_DAMAGE,
      FleetVehicleStatusEnum.UNAVAILABLE_DOCUMENTATION,
    ],
  },

  [FleetVehicleStatusEnum.UNAVAILABLE_SERVICE]: {
    label: "admin.fleet.vehicle.status.unavailable.service",
    color: "bg-slate-100 text-slate-800",
    dotColor: "bg-slate-500",
    strokeColor: "stroke-amber-500",
    parentStatus: FleetVehicleStatusEnum.UNAVAILABLE,
  },

  [FleetVehicleStatusEnum.UNAVAILABLE_DAMAGE]: {
    label: "admin.fleet.vehicle.status.unavailable.damage",
    color: "bg-orange-100 text-orange-800",
    dotColor: "bg-orange-500",
    strokeColor: "stroke-amber-500",
    parentStatus: FleetVehicleStatusEnum.UNAVAILABLE,
  },

  [FleetVehicleStatusEnum.UNAVAILABLE_DOCUMENTATION]: {
    label: "admin.fleet.vehicle.status.unavailable.documentation",
    color: "bg-slate-100 text-slate-800",
    dotColor: "bg-slate-500",
    strokeColor: "stroke-amber-500",
    parentStatus: FleetVehicleStatusEnum.UNAVAILABLE,
  },

  [FleetVehicleStatusEnum.SOLD]: {
    label: "admin.fleet.vehicle.status.sold",
    color: "bg-red-100 text-red-800",
    dotColor: "bg-red-500",
    strokeColor: "stroke-amber-500",
    parentStatus: null,
  },
};


/** Prag kilometraže za oznaku novog vozila */
const NEW_VEHICLE_KM_THRESHOLD = 7000;

/** Prag starosti vozila u mjesecima za oznaku novog vozila */
const NEW_VEHICLE_MONTHS_THRESHOLD = 6;

/** Vraća true ako je vozilo "novo" — manje od NEW_VEHICLE_KM_THRESHOLD km I (mlađe od NEW_VEHICLE_MONTHS_THRESHOLD mjeseci po datumu prve registracije ILI nema unesen datum prve registracije). */
export const isNewVehicle = (kmTraveled: number | null, firstRegistrationDate?: Date | string | null): boolean => {
  if (kmTraveled == null || kmTraveled > NEW_VEHICLE_KM_THRESHOLD) return false;

  if (firstRegistrationDate == null) return true;

  const now = new Date();
  const cutoffDate = new Date(now.getFullYear(), now.getMonth() - NEW_VEHICLE_MONTHS_THRESHOLD, 1);
  const registrationDate = new Date(firstRegistrationDate);

  return registrationDate >= cutoffDate;
};

export const ROOT_STATUSES = Object.entries(FLEET_VEHICLE_STATUS_CONFIG)
  .filter(([_, config]) => config.parentStatus === null)
  .map(([status]) => status as FleetVehicleStatusEnum);

/** Root status s pripadajućim pod-statusima — redoslijed prati VehicleStatusModal. */
export const VEHICLE_STATUS_GROUPS: {
  status: FleetVehicleStatusEnum;
  subStatuses: FleetVehicleStatusEnum[];
}[] = ROOT_STATUSES.map((status) => ({
  status,
  subStatuses: FLEET_VEHICLE_STATUS_CONFIG[status].subStatuses ?? [],
}));

/** Svi statusi (roditelji + pod-statusi) u jednoj ravnoj listi. */
export const ALL_VEHICLE_STATUSES: string[] = VEHICLE_STATUS_GROUPS.flatMap((group) => [
  group.status,
  ...group.subStatuses,
]);

/*---------------------------------------------------------------
    DETALJI UZ PROMJENU STATUSA
  ---------------------------------------------------------------*/

export const initialFleetVehicleStatusDetailForm: FleetVehicleStatusDetailFormValues = {
  validFrom: null,
  validUntil: null,
  note: null,
  contactId: null,
  driverId: null,
  vehicleDamageId: null,
  offerSaleId: null,
  kmTraveled: null,
  depositAmount: null,
  location: null,
  service: null,
};

/**
 * Koja polja traži koji status. Statusi kojih ovdje nema spremaju se bez dodatnog modala
 * (Prodano i Aktivno – U najmu dolaze iz ugovora).
 * Obavezna polja moraju odgovarati `VehicleStatusDetailValidator` na backendu.
 *
 * Polje "location" znači da status povlači i premještaj: unaprijed se popuni iz konteksta
 * (Servis -> taj servis, U dolasku -> dobavljač, Slobodno -> poslovnica), ali korisnik ga
 * može promijeniti — vozilo ne mora fizički biti tamo gdje status sugerira.
 */
export const FLEET_VEHICLE_STATUS_DETAIL_FIELDS: Partial<
  Record<FleetVehicleStatusEnum, FleetVehicleStatusDetailFieldConfig[]>
> = {
  [FleetVehicleStatusEnum.UNAVAILABLE_SERVICE]: [
    { field: "contact", label: "Servis", required: true, contactGroupIds: ["A"] },
    { field: "validFrom", label: "Datum zaprimanja" },
    { field: "validUntil", label: "Očekivani povratak" },
    { field: "kmTraveled", label: "Kilometraža" },
    { field: "note", label: "Opis zahvata" },
    {
      field: "location",
      label: "Lokacija vozila",
      locationType: VehicleLocationTypeEnum.SERVICE,
      locationDefault: "contact",
    },
  ],
  [FleetVehicleStatusEnum.UNAVAILABLE_DAMAGE]: [
    { field: "damage", label: "Šteta", required: true },
    { field: "validUntil", label: "Očekivani povratak" },
    { field: "note", label: "Napomena" },
  ],
  [FleetVehicleStatusEnum.UNAVAILABLE_DOCUMENTATION]: [
    { field: "note", label: "Koji dokument nedostaje", required: true },
    { field: "validUntil", label: "Očekivano rješenje" },
  ],
  [FleetVehicleStatusEnum.UNAVAILABLE]: [
    { field: "note", label: "Razlog", required: true },
    { field: "validUntil", label: "Očekivani povratak" },
  ],
  [FleetVehicleStatusEnum.RESERVED]: [
    { field: "contact", label: "Kupac", contactGroupIds: ["B"] },
    { field: "offerSale", label: "Ponuda" },
    { field: "validUntil", label: "Rezervirano do", required: true },
    { field: "depositAmount", label: "Kapara" },
  ],
  [FleetVehicleStatusEnum.ARRIVING]: [
    { field: "validFrom", label: "Očekivani datum dolaska", required: true },
    { field: "contact", label: "Dobavljač", contactGroupIds: ["S"] },
    {
      field: "location",
      label: "Lokacija vozila",
      locationType: VehicleLocationTypeEnum.SUPPLIER,
      locationDefault: "contact",
    },
  ],
  // Slobodno nema vlastitih detalja, ali se vozilo negdje vraća — bez ovoga bi ostalo
  // zavedeno kod servisera i nakon što je servis gotov.
  [FleetVehicleStatusEnum.AVAILABLE]: [
    {
      field: "location",
      label: "Lokacija vozila",
      locationType: VehicleLocationTypeEnum.OFFICE,
      locationDefault: "userOffice",
    },
  ],
  [FleetVehicleStatusEnum.ACTIVE_INTERNAL]: [
    { field: "driver", label: "Vozač", required: true },
    { field: "validFrom", label: "Zaduženo od" },
    { field: "validUntil", label: "Zaduženo do" },
    { field: "note", label: "Svrha" },
  ],
};

/**
 * Traži li status dodatni unos prije spremanja.
 *
 * `withoutLocation` isključuje lokaciju iz računice — kad je vozilo već premješteno,
 * status čija su sva polja lokacija nema što pitati, pa se sprema odmah.
 */
export const statusRequiresDetails = (
  status: FleetVehicleStatusEnum,
  withoutLocation = false
): boolean => {
  const fields = FLEET_VEHICLE_STATUS_DETAIL_FIELDS[status] ?? [];

  return withoutLocation
    ? fields.some((field) => field.field !== "location")
    : fields.length > 0;
};
